import type {FC} from 'react'
import {useEffect, useRef} from 'react'
import {useMutation} from 'react-query'
import {toast} from 'react-toastify'
import {useFormik} from 'formik'
import csvToJson from '../../../utils/csvToJson'
import {ModalDefault} from '../../ui'

interface Props {
  service: (...args: any[]) => Promise<any>
  id?: string
  isXLSX?: boolean
}

const ModalImport: FC<Props> = ({service, id, isXLSX}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const mutation = useMutation((...args: any[]) => {
    return service(...args[0])
  })

  const formik = useFormik({
    initialValues: {
      file: null as any,
    },
    onSubmit: (values) => {
      return new Promise((resolve, reject) => {
        if (isXLSX) {
          const formData = new FormData()
          formData.append('files', values.file)
          mutation.mutate([formData], {
            onSuccess: () => {
              toast.success('Success')
              formik.resetForm()
              inputRef.current!.value = ''
              resolve(values)
            },
            onError: (error: any) => {
              toast.error(error?.response?.data?.message)
              reject(error)
            },
          })
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          const result = e.target?.result
          if (result) {
            const data = JSON.parse(
              values.file.type === 'text/csv' ? csvToJson(result as string) : (result as string)
            )
            formik.resetForm()
            inputRef.current!.value = ''
            mutation.mutate([data, id], {
              onSuccess: () => {
                toast.success('Import Success')
                resolve(values)
              },
              onError(error: any, variables, context) {
                toast.error(error.response?.data?.error?.message)
                reject(error)
              },
            })
          }
        }
        reader.onerror = (e) => {
          console.log(e)
          reject(e)
        }
        reader.readAsText(values.file)
      })
    },
  })

  useEffect(() => {
    document.getElementById('import-modal')?.addEventListener('hidden.bs.modal', () => {
      formik.resetForm()
      inputRef.current!.value = ''
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <ModalDefault id='import-modal' title='Import Space' hides={['footer']}>
      <form onSubmit={formik.handleSubmit}>
        <div className='d-flex flex-column align-items-center gap-4'>
          <input
            ref={inputRef}
            type='file'
            id='import-upload-input'
            className='form-control mb-6'
            onChange={(e) => {
              formik.setFieldValue('file', e.target.files![0])
            }}
          />
        </div>
        <div className='d-flex justify-content-end gap-4'>
          <button type='button' id='close-modal' className='btn btn-light' data-bs-dismiss='modal'>
            Cancel
          </button>
          <button disabled={formik.isSubmitting} type='submit' className='btn btn-primary'>
            Submit
          </button>
        </div>
      </form>
    </ModalDefault>
  )
}

export default ModalImport
